import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { em } from '../../../../../utils/styles'

const FormUploadButton = styled.button`
  margin: 0;
  padding: ${em(3)} ${em(5)};
  border: 0;
  border-radius: ${em(5)};
  background-color: transparent;
  font-weight: ${theme('fontWeights.bold')};
  cursor: pointer;

  svg {
    display: inline-block;
    height: ${em(18)};
  }
`

export default FormUploadButton
